'use client';

import usePageTracking from '../utils/usePageTracking';

function PageTrackingWrapper() {
  usePageTracking();
  return null;
}

export default PageTrackingWrapper;

